import React from 'react';

import {TriangleLocation} from 'notebook/tables/errors/ErrorTriangle';
import {
  RunValidationConnector,
  RunValidationConnectorEnhancedProps,
  RunValidationConnectorInputProps,
} from 'results/validation/RunValidationConnector';
import ValidationIndicator from 'results/validation/ValidationIndicator';
import AssayDataNotePart from 'runs/assay-group/AssayDataNotePart';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

interface AssayGroupContainerProps extends RunValidationConnectorInputProps {
  children: React.ReactNode;
  indentation: number;
  isLoading?: boolean;
  title: React.ReactNode;
  showValidationSideBar?: boolean;
}

function AssayGroupContainer({
  assayRunValidation,
  children,
  indentation,
  isLoading = false,
  showValidationSideBar,
  title,
}: AssayGroupContainerProps & RunValidationConnectorEnhancedProps): JSX.Element {
  return (
    <AssayDataNotePart
      includeWrapper={true}
      indentation={indentation}
      showValidationSideBar={showValidationSideBar}
    >
      {isLoading ? (
        <CenteredHorizontalThrobber />
      ) : (
        <div>
          <ValidationIndicator
            assayValidationToDisplay={assayRunValidation}
            location={TriangleLocation.RUN}
          />
          <div className="resultsAttachment-header">{title}</div>
          {children}
        </div>
      )}
    </AssayDataNotePart>
  );
}

class AssayGroupRunValidationConnector extends RunValidationConnector<AssayGroupContainerProps> {}
export default AssayGroupRunValidationConnector.connect(AssayGroupContainer);
